import React from 'react';
export function Footer() {
  return <footer className="bg-deco-text text-deco-card py-12 px-4 text-center" data-id="element-61">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-6" data-id="element-62">
        <img src="https://cdn.magicpatterns.com/uploads/qJustZMxmxDKBZsGFJMSjj/LOGO_DECOEMPRENDE.png" alt="Deco Emprende" className="h-20 object-contain opacity-80 brightness-0 invert" data-id="element-63" />

        <div className="max-w-md" data-id="element-64">
          <h3 className="font-serif text-xl sm:text-2xl text-deco-warm/90 tracking-wide mb-2" data-id="element-65">
            Flores Eternas Deco
          </h3>
          <p className="text-deco-card/70 text-sm sm:text-base mb-4" data-id="element-66">
            Creá flores, ramos y regalos personalizados con limpiapipas, desde
            cero y desde casa.
          </p>
          <p className="text-deco-terra/90 font-medium text-sm" data-id="element-67">
            Deco Emprende — Manualidades creativas para aprender, disfrutar y
            emprender.
          </p>
        </div>

        <div className="w-16 h-px bg-deco-card/20 my-2" data-id="element-68" />

        <p className="text-deco-card/40 text-xs sm:text-sm" data-id="element-69">
          © {new Date().getFullYear()} Deco Emprende. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}